import { render } from "./navmenubutton.vue?vue&type=template&id=e84a7f9e"
import script from "./navmenubutton.vue?vue&type=script&lang=js"
export * from "./navmenubutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__